<!-- App Main Structure -->
<template>
  <div>
    <appHorizontalMenus></appHorizontalMenus>
    <div style="padding-top: 65px;">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AppHorizontalMenus from '@/components/AppHorizontalMenu'
export default {
  data () {
    return {
    }
  },
  components: {
    appHorizontalMenus:AppHorizontalMenus
  }
}
</script>
